import request from './request';
export const Authorize = '/Ceiba.PlaySrv/ActivityAuthorize';
export const GetActivityAuthorize = '/Ceiba.PlaySrv/GetActivityAuthorize';
export const GetInviteCode = '/Ceiba.PlaySrv/GetInviteCode';
export const GetInviteInfo = '/Ceiba.PlaySrv/GetInviteInfo';
export const GetCommandCode = '/Ceiba.PlaySrv/GetCommandCode';
export const GetCommandInfo = '/Ceiba.PlaySrv/GetCommandInfo';
export const GetActivityRoleInfo = '/Ceiba.PlaySrv/GetActivityRoleInfo';
export default class User {
  static activityAuthorize(params) {
    return request.post(Authorize, { ...params });
  }

  static async getActivityAuthorize(params) {
    try {
      const data = await request.post(GetActivityAuthorize, { ...params });
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async getInviteCode(params) {
    try {
      const data = await request.post(GetInviteCode, { ...params });
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async getInviteInfo(params) {
    try {
      const data = await request.post(GetInviteInfo, { ...params });
      return data;
    } catch (error) {
      throw error;
    }
  }
  static async getCommandCode(params) {
    try {
      const data = await request.post(GetCommandCode, { ...params });
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async getCommandInfo(params) {
    try {
      const data = await request.post(GetCommandInfo, { ...params });
      return data;
    } catch (error) {
      throw error;
    }
  }
  static async getActivityRoleInfo(params) {
    try {
      const data = await request.post(GetActivityRoleInfo, { ...params });
      return data;
    } catch (error) {
      throw error;
    }
  }
}
